import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import {
  currentOrderType,
  setCurrentOrderType,
  setSelectedDeliveryType,
  toggleClick,
} from '../common/features/restaurant/restaurantAction';
import { setSelectedOrderType } from '../common/features/cart/cartActions';
import { ACCESS_TOKEN, USER_DETAILS, USER_ID } from '../common/constants';
import { deleteCookie, getCookie } from '../helper/cookieHelper';

const useHeader = ({
  handleBack,
  currentOrdertypeDetails,
  menuType,
  setCurrentOrdertypeDetails,
}: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isCart, setIsCart] = useState(false);
  const [switchingOrderType, setSwitchingOrderType] = useState(false);
  let { merchantType, merchantSlug, orderId, tableId, eventDate } = useParams<any>();

  const isMobile = useSelector((state: any) => state?.navigation?.isMobile);

  const activeOrdersRaw = localStorage.getItem('ACTIVE_ORDERS');

  const orderInfo: any = activeOrdersRaw ? JSON.parse(activeOrdersRaw) : null;
  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);
  const slugFromLocalStorage =
    localStorage.getItem('restaurant') && JSON.parse(localStorage.getItem('restaurant') || '');
  const cdOrdersItems = useSelector((state: any) => state.order.currentOrderDetail?.kotItems);
  const [showLogout, setShowLogout] = useState(false);

  const basePath = `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu`;

  const PickupOrderType = restaurantDetails?.orderTypes?.filter(
    (item: any) => item.typeGroup === 'P'
  );
  const DeliveryOrderType = restaurantDetails?.orderTypes?.filter(
    (item: any) => item.typeGroup === 'S'
  );

  const selectedDeliveryType = useSelector((state: any) => state.restaurant.selectedDeliveryType);

  const cartRestaurantDetails = useSelector((state: any) => state.cart.cartRestaurantDetails);
  const currentOrderTypeid = useSelector((state: any) => state.restaurant.currentOrderTypeid);

  const cartData = useSelector((state: any) => state.cart?.cart?.items);

  const initialOrderTypeidPickup = restaurantDetails?.orderTypes?.find(
    (item: any) => item.typeGroup === 'P'
  );

  const DeliveryorderTyepid = restaurantDetails?.orderTypes?.find(
    (item: any) => item.typeGroup === 'S'
  );

  useEffect(() => {
    let orderTypeId = restaurantDetails?.orderTypes?.find(
      (item: any) => item.typeName === currentOrdertypeDetails?.[0]?.typeName
    )?.id;
    orderTypeId && dispatch(currentOrderType(orderTypeId));
  }, [currentOrdertypeDetails]);

  useEffect(() => {
    if (menuType === 'Delivery') {
      handleDeliveryClick();
      dispatch(toggleClick());
    } else if (menuType === 'Pickup') {
      handlePickupClick();
      dispatch(toggleClick());
    }
  }, [menuType]);

  useEffect(() => {
    dispatch(setSelectedDeliveryType(slugFromLocalStorage?.menuType));
  }, [slugFromLocalStorage?.menuType]);

  const handlePickupClick = () => {
    dispatch(setSelectedDeliveryType('Pickup'));
    dispatch(setSelectedOrderType('pickup'));
    // setSwitchingOrderType(true);
    dispatch(currentOrderType(initialOrderTypeidPickup?.id));
    dispatch(setCurrentOrderType('Pickup'));
    setCurrentOrdertypeDetails(initialOrderTypeidPickup ? [initialOrderTypeidPickup] : []);
  };

  const handleDeliveryClick = () => {
    dispatch(setSelectedDeliveryType('Delivery'));
    dispatch(setSelectedOrderType('delivery'));
    // setSwitchingOrderType(true);
    dispatch(currentOrderType(DeliveryorderTyepid?.id));
    dispatch(setCurrentOrderType('Delivery'));
    setCurrentOrdertypeDetails(DeliveryorderTyepid ? [DeliveryorderTyepid] : []);
  };

  const getImageURL = useCallback(
    (type: string) => {
      if (restaurantDetails && restaurantDetails?.media?.length > 0) {
        const logoMedia =
          restaurantDetails &&
          restaurantDetails?.media?.filter((media: any) => media?.entityType == type)[0];

        return (
          logoMedia?.mimeType &&
          process.env.REACT_APP_IMAGE_URL +
            logoMedia?.mimeType.split('/')[0] +
            '/' +
            logoMedia?.id +
            '.' +
            logoMedia?.mimeType.split('/')[1]
        );
      } else {
        return '';
      }
    },
    [restaurantDetails]
  );

  const goBack = () => {
    if (handleBack) {
      handleBack();
    } else {
      navigate(-1);
    }
  };

  const customerId = getCookie(USER_ID) || '';

  const cart = useSelector((state: any) => state.cart.cart.items);
  const cartOrderId = useSelector((state: any) => state.cart.orderId);
  const orderDetails = useSelector((state: any) => state.order.currentOrderDetail);

  const currentOrderTypeId = restaurantDetails?.orderTypes?.find(
    (o: any) => slugFromLocalStorage?.menuType === o?.typeName
  )?.id;

  const CartItemIds = cart?.map((item: any) => item?.itemId);
  const [cartItem, setCartItem] = useState(false);

  const handleLogoutclick = () => {
    navigate(`/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/account/`);
  };
  useEffect(() => {
    if (window.location.pathname.includes('/account')) {
      setIsCart(true);
    } else if (isMobile) {
      setIsCart(false);
    }
    if (cart.length > 0) {
      setIsCart(true);
    } else {
      setIsCart(false);
    }
  }, [cart]);

  return {
    isCart,
    goBack,
    getImageURL,
    restaurantDetails,
    selectedDeliveryType,
    setCartItem,
    CartItemIds,
    customerId,
    basePath,
    setSwitchingOrderType,
    tableId,
    orderDetails,
    orderInfo,
    slugFromLocalStorage,
    handleLogoutclick,
    cdOrdersItems,
    showLogout,
    setShowLogout,
    switchingOrderType,
    cartData,
  };
};

export default useHeader;
